import { InterestsEnum } from '@sweatpals/shared';

import AerialImage from '@/public/assets/images/fitness-skills/aerial.jpeg';
import BasketballImage from '@/public/assets/images/fitness-skills/basketball.png';
import BarreImage from '@/public/assets/images/fitness-skills/barre.jpeg';
import BreathworkImage from '@/public/assets/images/fitness-skills/breathwork.png';
import CrossfitImage from '@/public/assets/images/fitness-skills/crossfit.png';
import CyclingImage from '@/public/assets/images/fitness-skills/cycling.png';
import CalisthenicsImage from '@/public/assets/images/fitness-skills/calisthenics.jpeg';
import FootballImage from '@/public/assets/images/fitness-skills/football.jpeg';
import IcebathImage from '@/public/assets/images/fitness-skills/ice-bath.jpeg';
import GolfImage from '@/public/assets/images/fitness-skills/golf.jpeg';
import DanceImage from '@/public/assets/images/fitness-skills/dance.png';
import BoxingImage from '@/public/assets/images/fitness-skills/boxing.jpeg';
import FoodImage from '@/public/assets/images/fitness-skills/food.jpeg';
import HikingImage from '@/public/assets/images/fitness-skills/hiking.png';
import QIGongImage from '@/public/assets/images/fitness-skills/qi-gong.jpeg';
import PickleBallImage from '@/public/assets/images/fitness-skills/pickleball.png';
import SkateBoardingImage from '@/public/assets/images/fitness-skills/skateboarding.jpeg';
import HIITImage from '@/public/assets/images/fitness-skills/hiit.png';
import PilatesImage from '@/public/assets/images/fitness-skills/pilates.png';
import RollerSkatingImage from '@/public/assets/images/fitness-skills/roller-skating.jpeg';
import SoccerImage from '@/public/assets/images/fitness-skills/soccer.png';
import SkiingImage from '@/public/assets/images/fitness-skills/skiing.jpeg';
import SurfingImage from '@/public/assets/images/fitness-skills/surfing.jpeg';
import ShuffleDanceImage from '@/public/assets/images/fitness-skills/shuffle-dance.jpeg';
import LiftingImage from '@/public/assets/images/fitness-skills/lifting.png';
import SoundbathImage from '@/public/assets/images/fitness-skills/sound-bath.jpeg';
import MeditationImage from '@/public/assets/images/fitness-skills/meditation.jpg';
import MartialArtsImage from '@/public/assets/images/fitness-skills/martial-arts.png';
import MTBTrailRideImage from '@/public/assets/images/fitness-skills/mtb-trail-ride.jpeg';
import MTBTrailRidingImage from '@/public/assets/images/fitness-skills/mtb-trail-riding.jpeg';
import PaddleBoardingImage from '@/public/assets/images/fitness-skills/paddle-boarding.png';
import ObstacleRacingImage from '@/public/assets/images/fitness-skills/obstacle-racing.png';
import RockClimbingImage from '@/public/assets/images/fitness-skills/rock-climbing.png';
import SocialImage from '@/public/assets/images/fitness-skills/social.jpeg';
import RunningImage from '@/public/assets/images/fitness-skills/running.png';
import WalkingImage from '@/public/assets/images/fitness-skills/walking.png';
import SwimmingImage from '@/public/assets/images/fitness-skills/swimming.png';
import TennisImage from '@/public/assets/images/fitness-skills/tennis.png';
import YogaImage from '@/public/assets/images/fitness-skills/yoga.png';
import VolleyballImage from '@/public/assets/images/fitness-skills/volleyball.png';
import AcroYogaImage from '@/public/assets/images/fitness-skills/acroyoga.jpeg';
import IndoorCyclingImage from '@/public/assets/images/fitness-skills/indoor_cycling.png';
import CampingImage from '@/public/assets/images/fitness-skills/camping.png';
import DogFriendlyImage from '@/public/assets/images/fitness-skills/dog_friendly.png';
import OutdoorImage from '@/public/assets/images/fitness-skills/outdoor.png';
import LadiesOnlyImage from '@/public/assets/images/fitness-skills/ladies_only.png';
import YoungProfessionalsImage from '@/public/assets/images/fitness-skills/young_proffs.png';
import GenZImage from '@/public/assets/images/fitness-skills/genz.png';
import MomsImage from '@/public/assets/images/fitness-skills/moms.png';
import LGBTQPlusImage from '@/public/assets/images/fitness-skills/lgbtqplus.png';
import WaterImage from '@/public/assets/images/fitness-skills/water.png';
import KidFriendlyImage from '@/public/assets/images/fitness-skills/kid_friendly.png';
import SpikeballImage from '@/public/assets/images/fitness-skills/spikeball.png';
import RowingImage from '@/public/assets/images/fitness-skills/rowing.png';
import OthersImage from '@/public/assets/icons/others-interest.svg';
import { find } from 'lodash-es';

export enum InterestsCategoryKeysEnum {
	'RunWalk' = 'RunWalk',
	'Yoga' = 'Yoga',
	'PickupGames' = 'PickupGames',
	'StrengthTraining' = 'StrengthTraining',
	'Mindfulness' = 'Mindfulness',
	'Cycling' = 'Cycling',
	'Dance' = 'Dance',
	'Water' = 'Water',
	'Hiking' = 'Hiking',
	'Others' = 'Others',
}

export interface Interest {
	id: InterestsEnum;
	name: string;
	renderName: string;
	value: { id: InterestsEnum; exclude?: boolean }[];
}

export const INTERESTS: Record<InterestsCategoryKeysEnum, Interest> = {
	[InterestsCategoryKeysEnum.RunWalk]: {
		id: InterestsEnum.Running,
		name: 'Running',
		renderName: 'Run/Walk',
		value: [
			{ id: InterestsEnum.Running },
			{ id: InterestsEnum.Walking },
		],
	},
	[InterestsCategoryKeysEnum.Yoga]: {
		id: InterestsEnum.Yoga,
		name: 'Yoga',
		renderName: 'Yoga',
		value: [
			{ id: InterestsEnum.Yoga },
			{ id: InterestsEnum.AcroYoga },
		],
	},
	[InterestsCategoryKeysEnum.PickupGames]: {
		id: InterestsEnum.Soccer,
		name: 'Soccer',
		renderName: 'Pickup Games',
		value: [
			{ id: InterestsEnum.Soccer },
			{ id: InterestsEnum.Football },
			{ id: InterestsEnum.Basketball },
			{ id: InterestsEnum.Volleyball },
			{ id: InterestsEnum.Pickleball },
			{ id: InterestsEnum.Tennis },
		],
	},
	[InterestsCategoryKeysEnum.StrengthTraining]: {
		id: InterestsEnum.HIIT,
		name: 'HIIT',
		renderName: 'Strength Training',
		value: [
			{ id: InterestsEnum.HIIT },
			{ id: InterestsEnum.Pilates },
			{ id: InterestsEnum.CrossFit },
			{ id: InterestsEnum.Lifting },
			{ id: InterestsEnum.ObstacleRacing },
			{ id: InterestsEnum.Boxing },
			{ id: InterestsEnum.RockClimbing },
			{ id: InterestsEnum.Calisthenics },
		],
	},
	[InterestsCategoryKeysEnum.Mindfulness]: {
		id: InterestsEnum.Breathwork,
		name: 'Breathwork',
		renderName: 'Mindfulness',
		value: [
			{ id: InterestsEnum.Breathwork },
			{ id: InterestsEnum.Icebath },
			{ id: InterestsEnum.Meditation },
			{ id: InterestsEnum.Soundbath },
		],
	},
	[InterestsCategoryKeysEnum.Cycling]: {
		id: InterestsEnum.Cycling,
		name: 'Cycling',
		renderName: 'Cycling',
		value: [
			{ id: InterestsEnum.Cycling },
			{ id: InterestsEnum.MTBTrailRiding },
			{ id: InterestsEnum.MTBTrailRide },
		],
	},
	[InterestsCategoryKeysEnum.Dance]: {
		id: InterestsEnum.Dance,
		name: 'Dance',
		renderName: 'Dance',
		value: [
			{ id: InterestsEnum.Dance },
			{ id: InterestsEnum.ShuffleDance },
		],
	},
	[InterestsCategoryKeysEnum.Water]: {
		id: InterestsEnum.Water,
		name: 'Water',
		renderName: 'Water',
		value: [
			{ id: InterestsEnum.Swimming },
			{ id: InterestsEnum.PaddleBoarding },
			{ id: InterestsEnum.Surfing },
		],
	},
	[InterestsCategoryKeysEnum.Hiking]: {
		id: InterestsEnum.Hiking,
		name: 'Hiking',
		renderName: 'Hiking',
		value: [{ id: InterestsEnum.Hiking }],
	},
	[InterestsCategoryKeysEnum.Others]: {
		id: InterestsEnum.Others,
		name: 'Others',
		renderName: 'Others',
		value: [
			{ id: InterestsEnum.Running },
			{ id: InterestsEnum.Walking },
			{ id: InterestsEnum.Yoga },
			{ id: InterestsEnum.AcroYoga },
			{ id: InterestsEnum.Soccer },
			{ id: InterestsEnum.Football },
			{ id: InterestsEnum.Basketball },
			{ id: InterestsEnum.Volleyball },
			{ id: InterestsEnum.Pickleball },
			{ id: InterestsEnum.Tennis },
			{ id: InterestsEnum.HIIT },
			{ id: InterestsEnum.Pilates },
			{ id: InterestsEnum.CrossFit },
			{ id: InterestsEnum.Lifting },
			{ id: InterestsEnum.ObstacleRacing },
			{ id: InterestsEnum.Boxing },
			{ id: InterestsEnum.RockClimbing },
			{ id: InterestsEnum.Calisthenics },
			{ id: InterestsEnum.Breathwork },
			{ id: InterestsEnum.Icebath },
			{ id: InterestsEnum.Meditation },
			{ id: InterestsEnum.Soundbath },
			{ id: InterestsEnum.Cycling },
			{ id: InterestsEnum.MTBTrailRiding },
			{ id: InterestsEnum.MTBTrailRide },
			{ id: InterestsEnum.Dance },
			{ id: InterestsEnum.ShuffleDance },
			{ id: InterestsEnum.Swimming },
			{ id: InterestsEnum.PaddleBoarding },
			{ id: InterestsEnum.Surfing },
			{ id: InterestsEnum.Hiking }
		],
	},
};

export const findInterestByValueId = (id: InterestsEnum): Interest => {
	const interest = find(INTERESTS, (interest: Interest) => {
		const foundValue = find(interest.value, { id });

		return !!foundValue && !foundValue?.exclude;
	});

	if (!interest) {
		return INTERESTS[InterestsCategoryKeysEnum.Others];
	}

	return interest;
};

export interface InterestImage {
	interest: InterestsEnum;
	image: string;
}

export const DEFAULT_INTEREST_IMAGE = OthersImage.src;

export const INTERESTS_IMAGES: Partial<Record<InterestsEnum, InterestImage>> = {
	[InterestsEnum.AcroYoga]: {
		interest: InterestsEnum.AcroYoga,
		image: AcroYogaImage.src,
	},
	[InterestsEnum.Aerial]: {
		interest: InterestsEnum.Aerial,
		image: AerialImage.src,
	},
	[InterestsEnum.Barre]: {
		interest: InterestsEnum.Barre,
		image: BarreImage.src,
	},
	[InterestsEnum.Boxing]: {
		interest: InterestsEnum.Boxing,
		image: BoxingImage.src,
	},
	[InterestsEnum.Breathwork]: {
		interest: InterestsEnum.Breathwork,
		image: BreathworkImage.src,
	},
	[InterestsEnum.Calisthenics]: {
		interest: InterestsEnum.Calisthenics,
		image: CalisthenicsImage.src,
	},
	[InterestsEnum.Dance]: {
		interest: InterestsEnum.Dance,
		image: DanceImage.src,
	},
	[InterestsEnum.Food]: {
		interest: InterestsEnum.Food,
		image: FoodImage.src,
	},
	[InterestsEnum.Football]: {
		interest: InterestsEnum.Football,
		image: FootballImage.src,
	},
	[InterestsEnum.Golf]: {
		interest: InterestsEnum.Golf,
		image: GolfImage.src,
	},
	[InterestsEnum.Icebath]: {
		interest: InterestsEnum.Icebath,
		image: IcebathImage.src,
	},
	[InterestsEnum.MartialArts]: {
		interest: InterestsEnum.MartialArts,
		image: MartialArtsImage.src,
	},
	[InterestsEnum.Meditation]: {
		interest: InterestsEnum.Meditation,
		image: MeditationImage.src,
	},
	[InterestsEnum.MTBTrailRide]: {
		interest: InterestsEnum.MTBTrailRide,
		image: MTBTrailRideImage.src,
	},
	[InterestsEnum.MTBTrailRiding]: {
		interest: InterestsEnum.MTBTrailRiding,
		image: MTBTrailRidingImage.src,
	},
	[InterestsEnum.PaddleBoarding]: {
		interest: InterestsEnum.PaddleBoarding,
		image: PaddleBoardingImage.src,
	},
	[InterestsEnum.Pickleball]: {
		interest: InterestsEnum.Pickleball,
		image: PickleBallImage.src,
	},
	[InterestsEnum.Pilates]: {
		interest: InterestsEnum.Pilates,
		image: PilatesImage.src,
	},
	[InterestsEnum.QiGong]: {
		interest: InterestsEnum.QiGong,
		image: QIGongImage.src,
	},
	[InterestsEnum.RollerSkating]: {
		interest: InterestsEnum.RollerSkating,
		image: RollerSkatingImage.src,
	},
	[InterestsEnum.ShuffleDance]: {
		interest: InterestsEnum.ShuffleDance,
		image: ShuffleDanceImage.src,
	},
	[InterestsEnum.SkateBoarding]: {
		interest: InterestsEnum.SkateBoarding,
		image: SkateBoardingImage.src,
	},
	[InterestsEnum.Skiing]: {
		interest: InterestsEnum.Skiing,
		image: SkiingImage.src,
	},
	[InterestsEnum.Soccer]: {
		interest: InterestsEnum.Soccer,
		image: SoccerImage.src,
	},
	[InterestsEnum.Social]: {
		interest: InterestsEnum.Social,
		image: SocialImage.src,
	},
	[InterestsEnum.Soundbath]: {
		interest: InterestsEnum.Soundbath,
		image: SoundbathImage.src,
	},
	[InterestsEnum.Surfing]: {
		interest: InterestsEnum.Surfing,
		image: SurfingImage.src,
	},
	[InterestsEnum.Volleyball]: {
		interest: InterestsEnum.Volleyball,
		image: VolleyballImage.src,
	},
	[InterestsEnum.ObstacleRacing]: {
		interest: InterestsEnum.ObstacleRacing,
		image: ObstacleRacingImage.src,
	},
	[InterestsEnum.HIIT]: {
		interest: InterestsEnum.HIIT,
		image: HIITImage.src,
	},
	[InterestsEnum.Yoga]: {
		interest: InterestsEnum.Yoga,
		image: YogaImage.src,
	},
	[InterestsEnum.RockClimbing]: {
		interest: InterestsEnum.RockClimbing,
		image: RockClimbingImage.src,
	},
	[InterestsEnum.Running]: {
		interest: InterestsEnum.Running,
		image: RunningImage.src,
	},
	[InterestsEnum.Walking]: {
		interest: InterestsEnum.Walking,
		image: WalkingImage.src,
	},
	[InterestsEnum.Hiking]: {
		interest: InterestsEnum.Hiking,
		image: HikingImage.src,
	},
	[InterestsEnum.Lifting]: {
		interest: InterestsEnum.Lifting,
		image: LiftingImage.src,
	},
	[InterestsEnum.CrossFit]: {
		interest: InterestsEnum.CrossFit,
		image: CrossfitImage.src,
	},
	[InterestsEnum.Tennis]: {
		interest: InterestsEnum.Tennis,
		image: TennisImage.src,
	},
	[InterestsEnum.Swimming]: {
		interest: InterestsEnum.Swimming,
		image: SwimmingImage.src,
	},
	[InterestsEnum.Cycling]: {
		interest: InterestsEnum.Cycling,
		image: CyclingImage.src,
	},
	[InterestsEnum.Basketball]: {
		interest: InterestsEnum.Basketball,
		image: BasketballImage.src,
	},
	[InterestsEnum.IndoorCycling]: {
		interest: InterestsEnum.IndoorCycling,
		image: IndoorCyclingImage.src,
	},
	[InterestsEnum.Camping]: {
		interest: InterestsEnum.Camping,
		image: CampingImage.src,
	},
	[InterestsEnum.DogFriendly]: {
		interest: InterestsEnum.DogFriendly,
		image: DogFriendlyImage.src,
	},
	[InterestsEnum.Outdoor]: {
		interest: InterestsEnum.Outdoor,
		image: OutdoorImage.src,
	},
	[InterestsEnum.LadiesOnly]: {
		interest: InterestsEnum.LadiesOnly,
		image: LadiesOnlyImage.src,
	},
	[InterestsEnum.YoungProfessionals]: {
		interest: InterestsEnum.YoungProfessionals,
		image: YoungProfessionalsImage.src,
	},
	[InterestsEnum.GenZ]: {
		interest: InterestsEnum.GenZ,
		image: GenZImage.src,
	},
	[InterestsEnum.Moms]: {
		interest: InterestsEnum.Moms,
		image: MomsImage.src,
	},
	[InterestsEnum.LGBTQPlus]: {
		interest: InterestsEnum.LGBTQPlus,
		image: LGBTQPlusImage.src,
	},
	[InterestsEnum.Water]: {
		interest: InterestsEnum.Water,
		image: WaterImage.src,
	},
	[InterestsEnum.KidFriendly]: {
		interest: InterestsEnum.KidFriendly,
		image: KidFriendlyImage.src,
	},
	[InterestsEnum.Spikeball]: {
		interest: InterestsEnum.Spikeball,
		image: SpikeballImage.src,
	},
	[InterestsEnum.Rowing]: {
		interest: InterestsEnum.Rowing,
		image: RowingImage.src,
	},

	[InterestsEnum.Others]: {
		interest: InterestsEnum.Others,
		image: OthersImage.src,
	},
};
